import { render, staticRenderFns } from "./TableSendEditResource.vue?vue&type=template&id=e196d4e2&scoped=true"
import script from "./TableSendEditResource.vue?vue&type=script&lang=js"
export * from "./TableSendEditResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e196d4e2",
  null
  
)

export default component.exports